import React from 'react';
import tw from 'twin.macro';

export const TableCell = ({ children, head, ...restProps }) => {
  const Type = head ? 'th' : 'td';
  return (
    <Type
      css={[tw`py-2 px-2 first-of-type:px-0 last:pr-0 md:py-3 text-left`, head && tw`pt-0 md:pt-0`]}
      {...restProps}
    >
      {children}
    </Type>
  );
};
